export default {
  EVERYONE: 'EVERYONE',
  CONNECTED: 'CONNECTED',
}
